import {CURRENT_STATISTIC_YEAR} from '@/constants';
import {StatisticValidationRule} from '@/resources';
import {StatisticItemValidationType} from '@/types';

export class ValidationUtils {
  static isEmptyValue = (value: unknown): boolean => {
    return value === null || value === undefined || value === '';
  };

  static isValidationRule = <T extends StatisticValidationRule>(
    validationRule: StatisticValidationRule,
    validationType: StatisticItemValidationType,
  ): validationRule is T => {
    return validationRule.name === validationType;
  };

  static isStringValue = (value: unknown): boolean => {
    return typeof value === 'string';
  };

  static isCurrentYearValue = (value: number): boolean => {
    return value === CURRENT_STATISTIC_YEAR;
  };

  static isInvalidNumberValue = (value: unknown): boolean => {
    return Number.isNaN(Number(value)) || this.isEmptyValue(value) || !this.isStringValue(value);
  };

  static isInvalidStringValue = (value: unknown): boolean => {
    return this.isEmptyValue(value) || !this.isStringValue(value);
  };
}
